export default {
  setData ({commit}, obj) {
    commit('setData', obj)
  },
  removeData ({commit}, key) {
    commit('removeData', key)
  },
  setWater ({commit}, obj) {
    commit('setWater', obj)
  },
  setCard ({commit}, obj) {
    commit('setCard', obj)
  },
  setCash ({commit}, obj) {
    commit('setCash', obj)
  },
  setTitle ({commit}, title) {
    commit('setTitle', title)
  }
}



// WEBPACK FOOTER //
// ./src/store/data/actions.js